module.exports = __webpack_public_path__ + "static/media/SDFSA_8-509w.e141e6f7.jpg";